import React from 'react';
import NavBar from 'shared/NavBar/NavBar';
import Footer from 'shared/Footer/Footer';
import css from './PanelWithoutContainer.module.scss';

const PanelWithoutContainer: React.FC<any> = ({ children }) => {
  return (
    <>
      <header>
        <NavBar />
      </header>
      <div className={css.wrapper}>{children}</div>
      <Footer />
    </>
  );
};

export default PanelWithoutContainer;
